<template>
  <div>
    <div
      v-html="prompt_adjusted_with_links"
      class="online-roundtable-prompt start-xs"
    />
  </div>
</template>
<script lang="babel">
  import { mapGetters } from 'vuex';

  export default {
    mounted() {
      window.renderMath();
    },
    data() {
      return {};
    },
    computed: {
      ...mapGetters([
        'getCurrentRT',
      ]),
      prompt_adjusted_with_links() {
        let prompt = this.getCurrentRT.prompt;
        let listItemsString = '';
        if (this.getCurrentRT.links.length > 0) {
          this.getCurrentRT.links.forEach((link) => {
            const linkTag = `<li> <a href="${link.link}"target="_blank"> ${link.title} </a></li>`;
            listItemsString = listItemsString.concat(linkTag);
          });
          prompt = prompt.concat(`<hr /> Links: <ol> ${listItemsString} </ol>`);
        }
        return prompt;
      },
    },
  };
</script>

<style scoped lang="stylus"></style>



// WEBPACK FOOTER //
// promptInSubmitPage.vue?7d2bb327